import {
  applyRefinements,
  conditionalRequired,
  oneOf,
  requiredSchema
} from '@unistocks/components/form/validators';
import { Paragraph } from '@unistocks/components/text/text';
import { CalendarLayout } from '@unistocks/features/dashboard/components/dashboard-data/date/layout';
import { CalendarLayoutSelect } from '@unistocks/features/dashboard/components/dashboard-data/date/layouts/layout-select';
import { PortfolioFilter } from '@unistocks/features/dashboard/components/settings/portfolio-filter';
import { DashboardItemSettingsDto } from '@unistocks/proxy/axios-client';
import { t } from '@unistocks/shared/localization/index.ts';
import { useFormContext, useWatch } from 'react-hook-form';
import { z } from 'zod';

export const calendarSchemaFactory = () =>
  applyRefinements(
    z.object({
      portfolios: z.array(z.string()).nullish(),
      layout: requiredSchema(
        oneOf([CalendarLayout.Date, CalendarLayout.Events]),
        t('::Layout')
      )
    }),
    conditionalRequired(
      (layout: CalendarLayout) => layout === CalendarLayout.Events,
      'portfolios',
      { dependsOn: ['layout'], fieldName: t('::Portfolios') }
    )
  );

export const CalendarSettingsContentStep: React.FC = () => {
  return (
    <>
      <Paragraph mb={'$2'}>{t('::Dashboard:Settings:Date:HelpText')}</Paragraph>
      <PortfolioFilter
        sectionSelectOverrides={{ hidden: true }}
        assetTypeSelectOverrides={{ hidden: true }}
        portfolioSelectOverrides={{ isRequired: false }}
      />
    </>
  );
};

CalendarSettingsContentStep.displayName = 'CalendarSettingsContentStep';

export const CalendarSettingsLayoutStep: React.FC = () => {
  const { setValue } = useFormContext<DashboardItemSettingsDto>();
  const layout = useWatch<DashboardItemSettingsDto, 'layout'>({ name: 'layout' });

  return <CalendarLayoutSelect value={layout} onChange={value => setValue('layout', value)} />;
};

CalendarSettingsLayoutStep.displayName = 'CalendarSettingsLayoutStep';
